const RequestRemedyTabs = Object.freeze({
  GENERAL_INFORMATION: 0,
  SERVICES: 1,
});

export default RequestRemedyTabs;
